// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"456881ab","456":"5af4bc97","656":"c12d1ed3","756":"be0c3b27","787":"31716db0","968":"929b76b0"}[chunkId] + ".chunk.js";
};